import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconReceiptionBell2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"receiption-bell-2, concierge, assistant"} maskId="square-filled-radius-0-stroke-1-IconReceiptionBell2"><path d="M15 4H12.502V5.5127C18.3097 5.77887 22 10.6585 22 16.5V17H12.5V19H22V20H2V19H11.5V17H2V16.5C2 10.6571 5.69198 5.77687 11.502 5.5127V4H9V3H15V4Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconReceiptionBell2;
